export default {"src":"/_next/static/media/404.db8c8abe.svg","height":221,"width":400,"blurWidth":0,"blurHeight":0};